import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { BOOLEAN, DATE, DATE_TIME, ENUMERATION, NUMBER, STRING } from 'customer-data-objects/property/PropertyTypes';
import { Map as ImmutableMap, OrderedSet } from 'immutable';
import { hasDynamicDateFilters, hasPropertyComparisons } from '../../permissions/gates';
const PHONE_NUMBER = 'phone_number';
const dateDefaultsCRMSearch = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.Less, Operators.Greater, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown, Operators.UpdatedAfter, Operators.UpdatedBefore);
const dateDefaultsSalesViews = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.BeforeDateStaticOrDynamic, Operators.AfterDateStaticOrDynamic, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown, Operators.UpdatedAfter, Operators.UpdatedBefore);
const CRMSearchTypeToOperator = ImmutableMap({
  [PHONE_NUMBER]: OrderedSet.of(Operators.Known, Operators.NotKnown),
  [BOOLEAN]: OrderedSet.of(Operators.Equal, Operators.NotEqual, Operators.Known, Operators.NotKnown),
  [DATE]: dateDefaultsCRMSearch,
  [DATE_TIME]: dateDefaultsCRMSearch,
  [ENUMERATION]: OrderedSet.of(Operators.In, Operators.NotIn, Operators.Known, Operators.NotKnown),
  [NUMBER]: OrderedSet.of(Operators.Equal, Operators.NotEqual, Operators.Greater, Operators.GreaterOrEqual, Operators.Less, Operators.LessOrEqual, Operators.InRange, Operators.Known, Operators.NotKnown),
  [STRING]: OrderedSet.of(Operators.EqualAny, Operators.NotEqualAny, Operators.WildCardEqual, Operators.NotWildCardEqual, Operators.Known, Operators.NotKnown)
});
const SalesViewsTypeToOperator = ImmutableMap({
  [BOOLEAN]: OrderedSet.of(Operators.Equal, Operators.NotEqual, Operators.Known, Operators.NotKnown),
  [DATE]: dateDefaultsSalesViews,
  [DATE_TIME]: dateDefaultsSalesViews,
  [ENUMERATION]: OrderedSet.of(Operators.In, Operators.NotIn, Operators.Known, Operators.NotKnown),
  [NUMBER]: OrderedSet.of(Operators.Equal, Operators.NotEqual, Operators.Greater, Operators.GreaterOrEqual, Operators.Less, Operators.LessOrEqual, Operators.InRange, Operators.Known, Operators.NotKnown),
  [STRING]: OrderedSet.of(Operators.EqualAny, Operators.NotEqualAny, Operators.WildCardEqual, Operators.NotWildCardEqual, Operators.Known, Operators.NotKnown)
});

// Note: when gating, use legacyOperators to restrict access to gated operators
// clean up your override once ungated
export const getCRMSearchOperatorsForType = (type, __filterFamily, isUngated, options) => {
  if (!type) {
    return undefined;
  }
  if (options !== null && options !== void 0 && options.isRelativeTimeProperty) {
    if (type === DATE) {
      return OrderedSet.of(Operators.Less, Operators.Greater, Operators.LessOrEqual, Operators.GreaterOrEqual, Operators.Equal, Operators.NotEqual, Operators.Known, Operators.NotKnown);
    } else if (type === DATE_TIME) {
      return OrderedSet.of(Operators.Less, Operators.Greater, Operators.Known, Operators.NotKnown);
    }
  }
  if (type === DATE && !hasPropertyComparisons(isUngated)) {
    const legacyOperators = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.Less, Operators.Greater, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown);
    return legacyOperators;
  }
  if (type === DATE_TIME && !hasPropertyComparisons(isUngated)) {
    const legacyOperators = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.Less, Operators.Greater, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown);
    return legacyOperators;
  }
  return CRMSearchTypeToOperator.get(type);
};

// Note: when gating, use legacyOperators to restrict access to gated operators
// clean up your override once ungated
export const getSalesViewsOperatorsForType = (type, filterFamily, isUngated, options) => {
  if (!type) {
    return undefined;
  }
  if (type === DATE) {
    if (options !== null && options !== void 0 && options.isRelativeTimeProperty) {
      return OrderedSet.of(Operators.Less, Operators.Greater, Operators.LessOrEqual, Operators.GreaterOrEqual, Operators.Equal, Operators.NotEqual, Operators.Known, Operators.NotKnown);
    }
    if (!hasDynamicDateFilters(isUngated) && !hasPropertyComparisons(isUngated)) {
      const legacyOperators = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.Less, Operators.Greater, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown);
      return legacyOperators;
    } else if (hasDynamicDateFilters(isUngated) && !hasPropertyComparisons(isUngated)) {
      const legacyOperators = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.BeforeDateStaticOrDynamic, Operators.AfterDateStaticOrDynamic, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown);
      return legacyOperators;
    } else if (!hasDynamicDateFilters(isUngated) && hasPropertyComparisons(isUngated)) {
      const legacyOperators = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.Less, Operators.Greater, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown, Operators.UpdatedAfter, Operators.UpdatedBefore);
      return legacyOperators;
    }
  }
  if (type === DATE_TIME) {
    if (options !== null && options !== void 0 && options.isRelativeTimeProperty) {
      return OrderedSet.of(Operators.Less, Operators.Greater, Operators.Known, Operators.NotKnown);
    }
    if (!hasDynamicDateFilters(isUngated) && !hasPropertyComparisons(isUngated)) {
      const legacyOperators = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.Less, Operators.Greater, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown);
      return legacyOperators;
    } else if (hasDynamicDateFilters(isUngated) && !hasPropertyComparisons(isUngated)) {
      const legacyOperators = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.BeforeDateStaticOrDynamic, Operators.AfterDateStaticOrDynamic, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown);
      return legacyOperators;
    } else if (!hasDynamicDateFilters(isUngated) && hasPropertyComparisons(isUngated)) {
      const legacyOperators = OrderedSet.of(Operators.InRollingDateRange, Operators.Equal, Operators.Less, Operators.Greater, Operators.InRange, Operators.GreaterRolling, Operators.LessRolling, Operators.Known, Operators.NotKnown, Operators.UpdatedAfter, Operators.UpdatedBefore);
      return legacyOperators;
    }
  }
  return SalesViewsTypeToOperator.get(type);
};